// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__String from "melange/string.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(name) {
  return function (sizeOpt) {
    const size = sizeOpt !== undefined ? sizeOpt : "w-12 h-12";
    return function (textSizeOpt) {
      const textSize = textSizeOpt !== undefined ? textSizeOpt : "l";
      return function (className) {
        let logo_letter;
        let exit = 0;
        let first_letter;
        try {
          first_letter = Caml_string.get(name, 0);
          exit = 1;
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Stdlib.Invalid_argument) {
            logo_letter = "";
          } else {
            throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
          }
        }
        if (exit === 1) {
          logo_letter = Stdlib__String.make(1, first_letter);
        }
        return JsxRuntime.jsx("div", {
                    children: textSize === "l" ? JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                            className: "text-white",
                            children: logo_letter
                          }) : (
                        textSize === "m" ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                className: "text-white",
                                children: logo_letter
                              }) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                className: "text-white !text-3xl",
                                children: logo_letter
                              })
                      ),
                    className: Cn.fromList({
                          hd: "" + size + " flex items-center justify-center bg-default-gray rounded-50pct",
                          tl: {
                            hd: Cn.take(className),
                            tl: /* [] */0
                          }
                        })
                  });
      };
    };
  };
}

function LogoMaker(Props) {
  return Curry._2(make(Props.name)(Props.size), Props.textSize, Props.className);
}

const make$1 = LogoMaker;

export {
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
